import React, { useState } from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
} from 'mdb-react-ui-kit';
import NotificationListBody from './Tabs/NotificationLists/NotificationListBody';
import FavoritesBillsBody from './Tabs/FavoriteBills/FavoritesBillsBody';

const ListAndNotificationModal = ({ showListAndNotificationUI, setShowListAndNotificationUI }) => {

  const toggleOpen = () => setShowListAndNotificationUI(!showListAndNotificationUI);

  const [basicActive, setBasicActive] = useState('notificationListTab');

  const handleBasicClick = (value) => {
    if (value === basicActive) return;
    setBasicActive(value);
  };


  return (
    <>
      <MDBModal staticBackdrop tabIndex='-1' show={showListAndNotificationUI} onClose={() => setShowListAndNotificationUI(false)}>
        <MDBModalDialog size="xl">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Lists & Notifications</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <MDBTabs>
                <MDBTabsItem>
                  <MDBTabsLink onClick={() => handleBasicClick('notificationListTab')} active={basicActive === 'notificationListTab'} >
                    Notification Lists
                  </MDBTabsLink>
                </MDBTabsItem>
                <MDBTabsItem>
                  <MDBTabsLink onClick={() => handleBasicClick('favoriteBillsTab')} active={basicActive === 'favoriteBillsTab'}>
                    Favorite Bills
                  </MDBTabsLink>
                </MDBTabsItem>
              </MDBTabs>
              <MDBTabsContent className='bg-white p-3'>
                <NotificationListBody active={basicActive === 'notificationListTab'} />
                <FavoritesBillsBody active={basicActive === 'favoriteBillsTab'} />
              </MDBTabsContent>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color='primary' onClick={toggleOpen}>
                Save & Close
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}

export default ListAndNotificationModal;